var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 55 55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.8 45.247H13.933a2.85 2.85 0 0 1-2.666-1.893L.6 12.367a2.666 2.666 0 0 1 4.106-3.093l10.667 7.68A2.374 2.374 0 0 0 19 15.887l5.333-13.92a2.667 2.667 0 0 1 5.147 0l5.173 14a2.372 2.372 0 0 0 3.654 1.067L49.32 8.847a2.667 2.667 0 0 1 4.187 3.094l-11.04 31.413a2.67 2.67 0 0 1-2.667 1.893",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.666 33.967H20.333a2 2 0 0 1 0-4h13.333a2 2 0 1 1 0 4M40.653 53.541h-27.28a2 2 0 0 1 0-4h27.28a2 2 0 0 1 0 4"
  })));
};
export default SvgCrown;